import { render, staticRenderFns } from "./AnalisadoresProcesso.vue?vue&type=template&id=624ac398&scoped=true"
import script from "./AnalisadoresProcesso.vue?vue&type=script&lang=js"
export * from "./AnalisadoresProcesso.vue?vue&type=script&lang=js"
import style0 from "./AnalisadoresProcesso.vue?vue&type=style&index=0&id=624ac398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ac398",
  null
  
)

export default component.exports